'use client';
import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { useGetPageUrl } from '@/schema/useGetPageUrl';
import { Link as NextLink } from '@/shared/i18n/navigation';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { LocalizedString } from '@/shared/model/Language';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout> & { text: LocalizedString | string };

export const Link = ({ text, href, media, ...props }: Props) => {
    const t = useTranslations();
    const getLocalizedValue = useGetLocalizedValue();
    const getPageUrl = useGetPageUrl();
    const [prefix, ...parts] = href.split(':');
    const linkHref = prefix.startsWith('page') ? getPageUrl(parts.join('')) : href;
    return (
        <Layout
            element={NextLink}
            media={{ ...media, initial: { display: undefined, flexDirection: undefined, ...media?.initial } }}
            href={linkHref}
            {...props}
        >
            {typeof text === 'string' ? t(text as Parameters<typeof t>[0]) : getLocalizedValue(text)}
        </Layout>
    );
};
